<template>

    <v-container fluid="">
        <v-layout class="pa-0">
            <v-flex xs6>

                <v-text-field v-if="target == 'general'"               @change="change()" label="Naam" v-model="user.organisation.name"></v-text-field>
                <v-select                   v-if="target == 'general'" hide-selected @change="change()" label="Bedrijfstype" :items="organisations.types" item-text="description" item-value="reference" v-model="user.organisation.organisation_type"></v-select>

                <v-select                   v-if="target == 'general'" deletable-chips hide-selected chips @change="change()" label="Managed items" :items="types" item-text="description" item-value="reference" v-model="user.organisation.managed_list" multiple></v-select>
                <v-select                   v-if="target == 'general'" deletable-chips hide-selected chips @change="change()" label="CRM items" :items="types" item-text="description" item-value="reference" v-model="user.organisation.crm_list" multiple ></v-select>

                <v-text-field               v-if="target == 'email'" @change="change()" label="Email afzender" v-model="user.organisation.email_from"></v-text-field>
                <fields-d-email-field       v-if="target == 'email'" @change="change()" label="Reply email" v-model="user.organisation.email_reply_to"></fields-d-email-field>                
                <v-text-field               v-if="target == 'email'" @change="change()" label="Email link" v-model="user.organisation.email_link"></v-text-field>
                <v-text-field               v-if="target == 'email'" @change="change()" label="Email logo" v-model="user.organisation.email_logo"></v-text-field>
                <v-container v-if="target == 'email'">
                    <img :src="user.organisation.email_logo" alt="" width="200px">
                </v-container>                


                <span v-if="target == 'email'" class="caption dimgray--text">Email detail</span>
                <v-color-picker             v-if="target == 'email'" @input="change()" flat hide-mode-switch hide-canvas mode="hexa" v-model="user.organisation.email_detail_color"></v-color-picker>

                <span  v-if="target == 'email'" class="caption dimgray--text">Email button</span>
                <v-color-picker             v-if="target == 'email'" @input="change()" flat hide-mode-switch hide-canvas mode="hexa" v-model="user.organisation.email_button_color"></v-color-picker>

                <v-switch color="success" v-if="target == 'general' && user.authorization == 'superuser'" @change="change()" label="Formulieren" v-model="user.organisation.forms"></v-switch>
                <v-switch color="success" v-if="target == 'general' && user.authorization == 'superuser'" @change="change()" label="Generieke templates" v-model="user.organisation.generic_templates"></v-switch>


                <span v-if="target == 'general'" class="caption dimgray--text">Applicatie kleur</span> 
                <v-color-picker             v-if="target == 'general'" @input="change()" flat hide-mode-switch hide-canvas mode="hexa" v-model="user.organisation.application_color"></v-color-picker>
            
            </v-flex>   

            <v-flex xs6 v-if="target == 'general'">
                <settings-render-details></settings-render-details>
            </v-flex>

        </v-layout>      

        <v-layout justify-end="" style="min-height:78px;" class="pr-4">
            <v-flex :xs5="small" :md2="!small" :xs6="!small">
                <v-slide-x-transition>
                    <v-btn rounded="" block="" v-if="app.settings.change" @click="reset()" color="warning">Reset</v-btn>
                </v-slide-x-transition>
            </v-flex>
            <v-flex :xs5="small" :offset-xs1="small" :md2="!small" :xs6="!small">
                <v-slide-x-transition>
                    <v-btn rounded="" block="" v-if="app.settings.change" @click="store()" color="success">Opslaan</v-btn>
                </v-slide-x-transition>
            </v-flex>     

        </v-layout>
    </v-container>

</template>

<script>
import axios from "../../plugins/axios";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  props: {
    target: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    // change: false,
    small: false
  }),
  methods: {
    store() {
      this.$store.dispatch("user/updateOrganisation");
      this.$store.commit("app/resetChange");
    },
    reset() {
      this.$store.dispatch("user/getOrganisation");
      this.$store.commit("app/resetChange");
    },
    change() {
      this.$store.commit("app/setChange");
    }
  },
  computed: {
    ...mapState(["app", "user", "settings", "types", "type", "organisations"])
  }
};
</script>

<style scoped>
.app_color {
  color: silver;
}
</style>


